const OPTIONAL_FIELDS = [
  'guardian1_bus_stop',
  'guardian2_bus_stop',
  'school_bus_stop',
  'school_name',
] as const;

export const omitEmptyOptionalFields = <T extends object>(data: T): T => {
  const result = { ...data } as Record<string, unknown>;
  for (const field of OPTIONAL_FIELDS) {
    if (field in result && !result[field]) {
      delete result[field];
    }
  }
  return result as T;
};
